<template>
<w-tool-tabs class="tab-button" size="mini" v-model="activeTab">
  <el-row slot="tool" type="flex" justify="end">
    <w-config-edit-tool class="mr-r4" v-show="visibleEditButton"></w-config-edit-tool>
    <!-- 그룹 저장 -->
    <div>
      <el-button v-show="!isConfigEditing && visibleEditButton" type="secondary" size="small" @click="openGroupSavePopup">그룹 저장</el-button>
      <w-group-save-popup ref="groupSavePopup" :selected-obj="selectedNode" :config-data="configData" />
    </div>
  </el-row>
  <el-tab-pane label="구성 현황" name="WConfigStatus" >
    <w-config-status :activeTab="activeTab" :saveConfig="saveConfigFlag" :nodeParams="serverParams" @setConfigData="setConfigData"/>
  </el-tab-pane>
  <el-tab-pane label="변경이력" name="WChangeHistView">
    <w-change-hist-view :titleName="titleName" :activeTab="activeTab" :nodeParams="serverParams"></w-change-hist-view>
  </el-tab-pane>
  <el-tab-pane label="OS 정보" name="WOsInfoNode">
    <w-os-info-node :activeTab="activeTab" :nodeParams="serverParams"></w-os-info-node>
  </el-tab-pane>
  <el-tab-pane label="하드웨어" name="WHardwareInfoNode">
    <w-hardware-info-node :activeTab="activeTab" :nodeParams="serverParams"></w-hardware-info-node>
  </el-tab-pane>
  <el-tab-pane label="소프트웨어" name="WSoftwareInfoNode">
    <w-software-info-node :activeTab="activeTab" :nodeParams="serverParams"></w-software-info-node>
  </el-tab-pane>
  <el-tab-pane v-if="isWindowsNode" label="서비스목록" name="WServiceInfoNode">
    <w-service-info-node :activeTab="activeTab" :nodeParams="serverParams"></w-service-info-node>
  </el-tab-pane>
  <el-tab-pane v-if="isWindowsNode" label="공유폴더" name="WSharedFolderInfoNode">
    <w-shared-folder-info-node :activeTab="activeTab" :nodeParams="serverParams"></w-shared-folder-info-node>
  </el-tab-pane>
  <el-tab-pane label="예약작업" name="WSchedulingInfoNode">
    <w-scheduling-info-node :activeTab="activeTab" :nodeParams="serverParams"></w-scheduling-info-node>
  </el-tab-pane>
</w-tool-tabs>
</template>

<script>
import ConfigNodeTab from '@/mixins/config/config-node-tab';
import serverInfoAPI from '@/api/config/server/server-info';
import { mapGetters } from 'vuex';
import isNil from 'lodash/isNil';
import WConfigStatus from './configstatus';
import WOsInfoNode from './os';
import WHardwareInfoNode from './hardware';
import WSoftwareInfoNode from './software';
import WServiceInfoNode from './service';
import WSharedFolderInfoNode from './sharedFolder';
import WSchedulingInfoNode from './scheduling';
import WChangeHistView from '../common/ChangeHistView';

export default {
  name: 'WConfigServerNode',
  components: {
    WConfigStatus,
    WOsInfoNode,
    WHardwareInfoNode,
    WSoftwareInfoNode,
    WServiceInfoNode,
    WSharedFolderInfoNode,
    WSchedulingInfoNode,
    WChangeHistView,
  },
  mixins: [ConfigNodeTab],
  data() {
    return {
      titleName: '서버',
      saveConfigFlag: false,
      serverParams: {},
      isWindowsNode: false,
      params: {
        objId: null,
        managegroupId: 2,
      },
      activeTab: 'WConfigStatus',
      configData: {},
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(node) {
        if (!this.active) {
          return;
        }
        if (!isNil(node)) {
          this.params.objId = this.selectedNode.obj.objId;
          this.loadParams();
        }
      },
    },
    active(active) {
      if (active) {
        this.params.objId = this.selectedNode.obj.objId;
        this.loadParams();
      }
    },
  },
  methods: {
    /**
     * [loadParams 서버 > 구성의 하위탭에서 필요한 파라미터 조회]
     * @author yelim
     * @return {[type]}
     */
    loadParams() {
      const me = this;
      if (!isNil(this.params.objId)) {
        serverInfoAPI.getServerInfoList(this.params).then((result) => {
          if (result.data.success) {
            const serverResult = result.data.data.data;
            me.serverParams = result.data.data.data;
            me.serverParams.adminLabel = `[${serverResult.majorDepartment ? serverResult.majorDepartment : '-'}]${serverResult.majorName ? serverResult.majorName : '-'} /
            [${serverResult.minorDepartment ? serverResult.minorDepartment : '-'}]${serverResult.minorName ? serverResult.minorName : '-'}`;
            if (result.data.data.data.objCompanyName === 'Microsoft') {
              this.isWindowsNode = true;
            } else {
              this.isWindowsNode = false; // windows 전용 탭이 아닌 경우 노드 이동시 첫번째 탭을 선택하도록함
              this.activeTab = 'WConfigStatus';
            }
          }
        });
      }
    },
    /**
     * 구성 정보 데이터
     * @author jda
     */
    setConfigData(configData) {
      this.configData = configData;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/server/index.vue